import styled, { css } from 'styled-components';
import ReactSelect from 'react-select';
import { ContainerStyled, RowStyled, TableStyled } from '~/Components/Styled';

export const Container = styled(ContainerStyled)``;

export const Row = styled(RowStyled)`
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;
  h1 {
    white-space: nowrap;
  }
  .box-search {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    justify-content: flex-end;
  }
`;

export const CardsBox = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-bottom: 20px;
`;

export const ChartsBox = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-bottom: 20px;
`;

export const TableBox = styled.div`
  width: 100%;
  overflow-x: auto;
  margin-bottom: 20px;
`;

export const FilterBox = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-bottom: 20px;
`;

export const Select = styled(ReactSelect)`
  width: 180px;
  margin-right: 10px;
  ${props => props.invalid
    && css`
      > div {
        border-color: ${props.theme.colors.danger2};
      }
    `}
`;

export const BaseEmptyData = styled.div`
  flex: 1;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px dashed ${props => props.theme.colors.primary};
  border-radius: 15px;
`;
export const InfoEmptyData = styled.p`
  font-size: 18px;
  font-style: italic;
`;

export const Table = styled(TableStyled)`
  width: auto;
  thead {
    tr {
      th {
        padding: 10px;
        margin: 0;
        border: 1px solid ${props => props.theme.colors.regular};
        font-size: 14px !important;
      }
      th[align='center'] {
        text-align: center;
      }
      th[align='left'] {
        text-align: left;
      }
      th[align='right'] {
        text-align: right;
      }
    }
  }
  tbody {
    tr {
      td {
        padding: 10px;
        border: 1px solid ${props => props.theme.colors.regular};
        font-size: 14px !important;
      }
      td[align='center'] {
        text-align: center;
      }
      td[align='left'] {
        text-align: left;
      }
      td[align='right'] {
        text-align: right;
      }
    }
  }
`;

export const Separator = styled.div`
  width: 100%;
  border-top: 1px solid ${props => props.theme.colors.primary};
  margin-bottom: 20px;
`;
